/**
 * METER READING COLUMNS - CORRECT VERSION
 * Based on existing MeterReadingForm parameters
 */

import { ColumnDefinition, COLUMN_PRESETS } from '../../../universal_table';

// Grouped structure
export const METER_PARAMETER_GROUPS = [
  {
    group: 'TVM Export Values',
    parameters: [
      'Feeder1 Initial Export',
      'Feeder1 Final Export',
      'Feeder1 Net kWh'
    ]
  },
  {
    group: 'Inverter Generation for a Day',
    parameters: ['Inverter Generation 600V']
  },
  {
    group: 'Total import at 33 kV Line',
    parameters: [
      'Feeder1 Initial import kWh',
      'Feeder1 Final import kWh',
      'B01Ff1 Net Import kWh'
    ]
  }
];

// Flatten all parameters
export const ALL_METER_PARAMETERS = METER_PARAMETER_GROUPS.flatMap(group => group.parameters);

export const METER_READING_COLUMNS: ColumnDefinition[] = [
  {
    key: '_delete',
    label: '',
    type: 'action',
    sticky: true,
    minWidth: 40,
    editable: false,
    unitLabel: ''
  },
  {
    key: 'Date',
    label: 'Date',
    ...COLUMN_PRESETS.DATE,
    sticky: true,
    minWidth: 140,
    unitLabel: ''
  },
  // TVM Export Values Group
  {
    key: 'Feeder1 Initial Export',
    label: 'Feeder1 Initial Export',
    abbreviation: 'Initial Export',
    ...COLUMN_PRESETS.NUMBER,
    minWidth: 110,
    group: 'TVM Export Values',
    unitLabel: 'kWh',
    decimalPlaces: 1
  },
  {
    key: 'Feeder1 Final Export',
    label: 'Feeder1 Final Export',
    abbreviation: 'Final Export',
    ...COLUMN_PRESETS.NUMBER,
    minWidth: 110,
    group: 'TVM Export Values',
    unitLabel: 'kWh',
    decimalPlaces: 1
  },
  {
    key: 'Feeder1 Net kWh',
    label: 'Feeder1 Net kWh',
    abbreviation: 'Net kWh',
    ...COLUMN_PRESETS.CALCULATED,
    unitLabel: 'kWh',
    decimalPlaces: 1,
    calculateFn: (rowData) => {
      const initialStr = rowData['Feeder1 Initial Export'];
      const finalStr = rowData['Feeder1 Final Export'];
      
      if (!initialStr || !finalStr || initialStr.toString().trim() === '' || finalStr.toString().trim() === '') {
        return null;
      }
      
      const initial = parseFloat(initialStr.toString().trim());
      const final = parseFloat(finalStr.toString().trim());
      
      if (isNaN(initial) || isNaN(final)) {
        return null;
      }
      
      const diff = final - initial;
      return diff; // Return number, formatter will handle decimal places
    },
    dependencies: ['Feeder1 Initial Export', 'Feeder1 Final Export'],
    minWidth: 100,
    group: 'TVM Export Values'
  },
  // Inverter Generation Group
  {
    key: 'Inverter Generation 600V',
    label: 'Inverter Generation 600V',
    abbreviation: 'Generation 600V',
    ...COLUMN_PRESETS.NUMBER,
    unitLabel: 'kWh',
    minWidth: 120,
    group: 'Inverter Generation for a Day',
    decimalPlaces: 1
  },
  // Total Import Group
  {
    key: 'Feeder1 Initial import kWh',
    label: 'Feeder1 Initial import kWh',
    abbreviation: 'Initial Import',
    ...COLUMN_PRESETS.NUMBER,
    minWidth: 110,
    group: 'Total import at 33 kV Line',
    unitLabel: 'kWh',
    decimalPlaces: 1
  },
  {
    key: 'Feeder1 Final import kWh',
    label: 'Feeder1 Final import kWh',
    abbreviation: 'Final Import',
    ...COLUMN_PRESETS.NUMBER,
    minWidth: 110,
    group: 'Total import at 33 kV Line',
    unitLabel: 'kWh',
    decimalPlaces: 1
  },
  {
    key: 'B01Ff1 Net Import kWh',
    label: 'B01Ff1 Net Import kWh',
    abbreviation: 'Net Import',
    ...COLUMN_PRESETS.CALCULATED,
    unitLabel: 'kWh',
    decimalPlaces: 1,
    calculateFn: (rowData) => {
      const initialStr = rowData['Feeder1 Initial import kWh'];
      const finalStr = rowData['Feeder1 Final import kWh'];
      
      if (!initialStr || !finalStr || initialStr.toString().trim() === '' || finalStr.toString().trim() === '') {
        return null;
      }
      
      const initial = parseFloat(initialStr.toString().trim());
      const final = parseFloat(finalStr.toString().trim());
      
      if (isNaN(initial) || isNaN(final)) {
        return null;
      }
      
      const diff = final - initial;
      return diff; // Return number, formatter will handle decimal places
    },
    dependencies: ['Feeder1 Initial import kWh', 'Feeder1 Final import kWh'],
    minWidth: 110,
    group: 'Total import at 33 kV Line'
  }
];
